import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Admin, Site } from '@app-models/site';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthService } from '@app-services/auth.service';
import { ConfirmComponent } from '../../modals/confirm/confirm.component';
import { ChangePasswordComponent } from '../../modals/change-password/change-password.component';
import { SiteService } from '@app-services/site.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { errorMessages } from 'src/message/error';
import { LoadingScreenService } from '@app-services/loading-screen.service';
import { TextDialogComponent } from '../../core/text-dialog/text-dialog.component';

@Component({
  selector: 'app-user-manager',
  templateUrl: './user-manager.component.html',
  styleUrls: ['./user-manager.component.scss']
})
export class UserManagerComponent implements OnInit, OnDestroy {

  fg: FormGroup;
  e = errorMessages.TH;
  passwordDialogRef: MatDialogRef<ChangePasswordComponent>;
  confirmDialogRef: MatDialogRef<ConfirmComponent>;
  admin: Admin;
  readonly = true;
  eventSub: Subscription;
  curSite: Site;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private ss: SiteService,
    private as: AuthService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private ls: LoadingScreenService
  ) { }

  ngOnInit() {
    this.eventSub = this.route.params.subscribe(
      async (params: Params) => {
        this.curSite = await this.ss.getCurrentSite();
        this.ss.getAdmin(params.adminId).then(
          (admin: Admin) => {
            this.initFormControls(admin);
            this.admin = admin;
            // console.log(admin);
          }
        );
      }
    );
    this.ss.getCurrentAdmin().then(
      (admin: Admin) => {
        if (admin.role === 'super-admin') {
          this.readonly = false;
        }
      }).catch((reason) => {
        const textDialog = this.dialog.open(TextDialogComponent, {
          width: '300px',
          data: reason
        });
        textDialog.afterClosed().subscribe(
          (value) => {
            this.as.signOutUser();
          }
        );
      });
  }

  ngOnDestroy() {
    this.eventSub.unsubscribe();
  }


  initFormControls(admin: Admin) {
    this.fg = this.fb.group({
      name: [admin.name, Validators.required],
      phoneNumber: [admin.phoneNumber, Validators.required],
      email: [admin.email, [Validators.required, Validators.email]]
    });
  }

  updateAdmin(admin: Admin, changes: any) {
    this.ls.startLoading();
    this.ss.updateAdminInfo(this.curSite.id, admin, changes)
      .then((value: any) => { })
      .finally(() => { this.ls.stopLoading(); });
  }

  editFormGroup(update: boolean) {
    if (update) {
      this.admin.name = this.fg.get('name').value;
      this.admin.phoneNumber = this.fg.get('phoneNumber').value;
      this.admin.email = this.fg.get('email').value;
      this.updateAdmin(
        this.admin, {
        name: this.admin.name,
        phoneNumber: this.admin.phoneNumber,
        email: this.admin.email
      });
    } else {
      this.fg.get('name').setValue(this.admin.name);
      this.fg.get('phoneNumber').setValue(this.admin.phoneNumber);
      this.fg.get('email').setValue(this.admin.email);
    }
  }

  openChangePassword() {
    this.passwordDialogRef = this.dialog.open(ChangePasswordComponent, {
      width: '450px',
      data: this.admin
    });
  }

  confirmEnableChanged(event: MatSlideToggleChange) {
    // already changed
    // console.log(this.site.enabled);
    let actionMsg = 'ระงับ';
    if (this.admin.isEnabled) {
      actionMsg = 'เปิด';
    }
    const header = actionMsg + 'การใช้งานผู้ดูแล';
    const message = 'คุณกำลัง' + actionMsg + 'การใช้งานผู้ดูแล คุณต้องการดำเนินงานต่อหรือไม่';
    this.confirmDialogRef = this.dialog.open(
      ConfirmComponent, {
      data: { header, message }
    }
    );
    this.confirmDialogRef.afterClosed().subscribe(
      (confirm: any) => {
        if (confirm) {
          this.updateAdmin(this.admin, { isEnabled: this.admin.isEnabled });
        } else {
          this.admin.isEnabled = !this.admin.isEnabled;
        }
      }
    );
  }

  confirmDeleteDialog() {
    const header = null;
    const message = null;
    this.confirmDialogRef = this.dialog.open(
      ConfirmComponent, {
      data: { header, message }
    }
    );
    this.confirmDialogRef.afterClosed().subscribe(
      (confirm: any) => {
        if (confirm) {
          this.ls.startLoading();
          this.ss.deleteAdmin(this.curSite.id, this.admin)
            .then(() => {
              this.ss.deleteAdminLocal(this.admin);
              this.router.navigate(['../../'], { relativeTo: this.route });
            }).catch((reason: Error) => {
              const textDialog = this.dialog.open(TextDialogComponent, {
                width: '300px',
                data: reason.message
              });
            }).finally(() => {
              this.ls.stopLoading();
            });
        }
      }
    );
  }
}
